import { render } from "./PrinterComponent.vue?vue&type=template&id=e7965754&scoped=true&ts=true"
import script from "./PrinterComponent.vue?vue&type=script&lang=ts"
export * from "./PrinterComponent.vue?vue&type=script&lang=ts"

import "./PrinterComponent.vue?vue&type=style&index=0&id=e7965754&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7965754"]])

export default __exports__